function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openModal, openWriteToUs } from "@common/actions";
import { calculateMenuWidth } from "@common/services/helpers";
import PrismicClient from "@common/utils/prismic";
import { DISABLE_WRITE_TO_US, FREQUENTLY_ASKED_QUESTIONS, INSTALLATION_GUIDE, KEY_ENTER, KEY_SPACE } from "@config/constants";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { isEmpty } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
var HelpMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(HelpMenu, Component);
    var _super = _create_super(HelpMenu);
    function HelpMenu(props) {
        _class_call_check(this, HelpMenu);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            anchorEl: null,
            open: false,
            isVideoPlayerOpened: props.videoPlayer.isOpen,
            hasGuide: false
        };
        _this.handleClose = _this.handleClose.bind(_assert_this_initialized(_this));
        _this.helpMenuRef = null;
        _this.handleClick = _this.handleClick.bind(_assert_this_initialized(_this));
        _this.openModal = _this.openModal.bind(_assert_this_initialized(_this));
        _this.openWriteToUs = _this.openWriteToUs.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        _this.handleCloseFromKeyboard = _this.handleCloseFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(HelpMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                document.addEventListener("click", _this.handleClickOutside);
                                document.addEventListener("touchend", _this.handleClickOutside);
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                return [
                                    4,
                                    PrismicClient.getAppGuide()
                                ];
                            case 1:
                                prismicData = _state.sent();
                                if (!isEmpty(prismicData)) {
                                    _this.setState({
                                        hasGuide: true
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("click", this.handleClickOutside);
                document.removeEventListener("touchend", this.handleClickOutside);
            }
        },
        {
            // here we are checking if the videoPlayer isOpen state is being toggled
            // and we are closing the help menu if true
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps, nextState) {
                if (nextProps.videoPlayer.isOpen !== this.state.isVideoPlayerOpened) {
                    this.setState({
                        anchorEl: null,
                        isVideoPlayerOpened: nextProps.videoPlayer.isOpen
                    });
                }
                if (nextState.anchorEl !== this.state.anchorEl && !nextState.anchorEl && (nextProps.modal.isGdprOpened || nextProps.modal.isWriteToUsOpened || nextProps.modal.isModalOpened)) {
                    document.activeElement.blur();
                }
            }
        },
        {
            /**
     *  Handles click outside of help menu and calls
     *  handleClose method if click is outside help menu
     *  @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.helpMenuRef && !this.helpMenuRef.contains(event.target)) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Open help menu and close it on MenuItem click
     *  @param {Object} event
     */ key: "handleClick",
            value: function handleClick(event) {
                event.stopPropagation();
                var eventTarget = event.currentTarget;
                this.state.anchorEl ? this.handleClose() : this.setState({
                    anchorEl: eventTarget
                });
            }
        },
        {
            /**
     *  Toggles the help menu on enter/space keydown on help menu icon
     *  @param event {Object}
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.handleClick(event);
                }
            }
        },
        {
            /**
     *  Closes the help menu on enter/space keydown on its items
     *  @param event {Object}
     */ key: "handleCloseFromKeyboard",
            value: function handleCloseFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Closes the help menu
     */ key: "handleClose",
            value: function handleClose() {
                this.setState({
                    anchorEl: null
                });
            }
        },
        {
            /**
     *  Opens the modal
     *  @param event {Object}
     *  @param modalName {String}
     *  @param modalProps {Object}
     */ key: "openModal",
            value: function openModal(event, modalName, modalProps) {
                event.stopPropagation();
                this.props.openModal(modalName, modalProps);
            }
        },
        {
            /**
     *  Opens write to us modal
     *  @param event {Object}
     */ key: "openWriteToUs",
            value: function openWriteToUs(event) {
                event.stopPropagation();
                this.props.openWriteToUs();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, i18n = _this_props.i18n, screenType = _this_props.screenType;
                var anchorEl = this.state.anchorEl;
                if (this.state.anchorEl) {
                    this.props.setMenuFlag(true);
                } else {
                    this.props.setMenuFlag(false);
                }
                var menuAdditionalClass = videoPlayer.isOpen && !screenType.mobile ? " open-up" : "";
                var menuWidth = calculateMenuWidth();
                return /*#__PURE__*/ _jsxs("div", {
                    ref: function(node) {
                        return _this.helpMenuRef = node;
                    },
                    tabIndex: "".concat(this.state.open ? "0" : "-1"),
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-help pointer",
                            "aria-owns": anchorEl ? "help-menu" : null,
                            "aria-haspopup": "true",
                            "data-tip": i18n.common.help,
                            "data-for": "header-tooltip",
                            tabIndex: "".concat(this.state.open ? "-1" : "0"),
                            onKeyDown: this.toggleFromKeyboard,
                            onClick: this.handleClick
                        }),
                        /*#__PURE__*/ _jsxs(Menu, {
                            className: "menu".concat(menuAdditionalClass),
                            id: "help-menu",
                            anchorEl: anchorEl,
                            open: Boolean(anchorEl),
                            onClose: this.handleClose,
                            PaperProps: {
                                style: {
                                    minWidth: menuWidth
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(MenuItem, {
                                    className: "menu-item",
                                    onKeyDown: this.handleCloseFromKeyboard,
                                    onClick: function(event) {
                                        return _this.openModal(event, FREQUENTLY_ASKED_QUESTIONS);
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: " faq-icon"
                                        }),
                                        i18n.frequentlyAskedQuestions
                                    ]
                                }),
                                !DISABLE_WRITE_TO_US && /*#__PURE__*/ _jsxs(MenuItem, {
                                    className: "menu-item",
                                    onKeyDown: this.handleCloseFromKeyboard,
                                    onClick: function(event) {
                                        return _this.openWriteToUs(event);
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "write-to-us-icon"
                                        }),
                                        i18n.writeToUs
                                    ]
                                }),
                                this.state.hasGuide && /*#__PURE__*/ _jsxs(MenuItem, {
                                    className: "menu-item",
                                    onKeyDown: this.handleCloseFromKeyboard,
                                    onClick: function(event) {
                                        _this.props.history.push("/guide");
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: " apps-icon"
                                        }),
                                        i18n.common.apps
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("hr", {}),
                                /*#__PURE__*/ _jsx("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: i18n.contacts
                                    },
                                    className: "menu-item-contacts",
                                    tabIndex: 0
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return HelpMenu;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, videoPlayer = param.videoPlayer, screenType = param.screenType, modal = param.modal;
    return {
        i18n: i18n,
        videoPlayer: videoPlayer,
        screenType: screenType,
        modal: modal
    };
};
export default withRouter(connect(mapStateToProps, {
    openModal: openModal,
    openWriteToUs: openWriteToUs
})(HelpMenu));
